var map = {
	"./bronze.png": "94f2",
	"./comparison/anonymous-pro-dark.png": "d01e",
	"./comparison/anonymous-pro-light.png": "5b5b",
	"./comparison/cartograph-dark.png": "a252",
	"./comparison/cartograph-light.png": "ab4f",
	"./comparison/cascadia-code-dark.png": "df63",
	"./comparison/cascadia-code-light.png": "0c0f",
	"./comparison/consolas-dark.png": "885d",
	"./comparison/consolas-light.png": "ab41",
	"./comparison/dank-mono-dark.png": "0d89",
	"./comparison/dank-mono-light.png": "50b7",
	"./comparison/droid-sans-dark.png": "4a0c",
	"./comparison/droid-sans-light.png": "e270",
	"./comparison/fantasque-sans-mono-dark.png": "d94a",
	"./comparison/fantasque-sans-mono-light.png": "4f65",
	"./comparison/fira-code-dark.png": "0def",
	"./comparison/fira-code-light.png": "34ed",
	"./comparison/hack-dark.png": "78ec",
	"./comparison/hack-light.png": "3649",
	"./comparison/hasklig-dark.png": "e3bd",
	"./comparison/hasklig-light.png": "533c",
	"./comparison/inconsolata-dark.png": "c3d5",
	"./comparison/inconsolata-light.png": "995b",
	"./comparison/input-dark.png": "d8d0",
	"./comparison/input-light.png": "865c",
	"./comparison/iosevka-dark.png": "fb5a",
	"./comparison/iosevka-light.png": "d406",
	"./comparison/jetbrains-mono-dark.png": "3731",
	"./comparison/jetbrains-mono-light.png": "b273",
	"./comparison/meslo-dark.png": "c9e9",
	"./comparison/meslo-light.png": "31c7",
	"./comparison/monoid-dark.png": "3e10",
	"./comparison/monoid-light.png": "f282",
	"./comparison/monolisa-dark.png": "4a05",
	"./comparison/monolisa-light.png": "2b8e",
	"./comparison/operator-mono-dark.png": "3674",
	"./comparison/operator-mono-light.png": "b4ec",
	"./comparison/plex-mono-dark.png": "ae34",
	"./comparison/plex-mono-light.png": "5ac1",
	"./comparison/roboto-mono-dark.png": "fe85",
	"./comparison/roboto-mono-light.png": "e490",
	"./comparison/source-code-pro-dark.png": "a373",
	"./comparison/source-code-pro-light.png": "23f0",
	"./comparison/sudo-dark.png": "c5de",
	"./comparison/sudo-light.png": "c498",
	"./comparison/ubuntu-mono-dark.png": "4516",
	"./comparison/ubuntu-mono-light.png": "f84f",
	"./comparison/victor-mono-dark.png": "b65b",
	"./comparison/victor-mono-light.png": "6012",
	"./github.png": "d677",
	"./glyphs-dark.png": "667b",
	"./glyphs-light.png": "2287",
	"./gold.png": "3964",
	"./keyboard-dark.jpg": "fd7e",
	"./keyboard-light.jpg": "8309",
	"./merch-dark.jpg": "d9a2",
	"./merch-light.jpg": "880a",
	"./powerline-dark.png": "2ab4",
	"./powerline-light.png": "c01e",
	"./silver.png": "2231",
	"./specimen-dark.png": "b1f0",
	"./specimen-light.png": "4d2d",
	"./styles-dark-thumb.png": "2210",
	"./styles-dark.png": "b2d7",
	"./styles-light-thumb.png": "178f",
	"./styles-light.png": "0f35",
	"./unicorn.png": "478e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";